var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Active Backlog","chart":"column","chartType":"backlog","withDate":false,"withFinancial":false}})}
var staticRenderFns = []

export { render, staticRenderFns }